/**
 * @generated SignedSource<<316338130c9c3fbda0a8b0dc00d5ed92>>
 * @relayHash 5aecbf8ced643dda0fbf2090719a11fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider
    }
  }
};

export default node;
